import { render, staticRenderFns } from "./ChioseDialog.vue?vue&type=template&id=b1ec989e&scoped=true&"
import script from "./ChioseDialog.vue?vue&type=script&lang=js&"
export * from "./ChioseDialog.vue?vue&type=script&lang=js&"
import style0 from "./ChioseDialog.vue?vue&type=style&index=0&id=b1ec989e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1ec989e",
  null
  
)

export default component.exports